import { render, staticRenderFns } from "./quadrants-panel.component.vue?vue&type=template&id=c656c32e&scoped=true&"
import script from "./quadrants-panel.component.vue?vue&type=script&lang=ts&"
export * from "./quadrants-panel.component.vue?vue&type=script&lang=ts&"
import style0 from "./quadrants-panel.component.vue?vue&type=style&index=0&id=c656c32e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c656c32e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
